import types, { IAction } from '../../types/actions';

export interface IModalsState {
	changeAddress: boolean;
	changeInvoice: boolean;
	deliveryCalendar: boolean;
	filterModal: boolean;
	loginModal: boolean;
}

export const initialState: IModalsState = {
	loginModal: false,
	changeAddress: false,
	changeInvoice: false,
	deliveryCalendar: false,
	filterModal: false,
};

export const modalsReducer = (state = initialState, action: IAction) => {
	switch (action.type) {
		case types.USER_REGISTRATION_SUCCESS:
		case types.SET_LOGIN_MODAL: {
			return {
				...state,
				loginModal: !state.loginModal,
			};
		}
		case types.CLOSE_LOGIN_MODAL: {
			return {
				...state,
				loginModal: false,
			};
		}
		case types.SET_CHANGE_ADDRESS_MODAL: {
			return {
				...state,
				changeAddress: !state.changeAddress,
			};
		}
		case types.CLOSE_CHANGE_ADDRESS_MODAL: {
			return {
				...state,
				changeAddress: false,
			};
		}
		case types.SET_CHANGE_INVOICE_MODAL: {
			return {
				...state,
				changeInvoice: !state.changeInvoice,
			};
		}
		case types.CLOSE_CHANGE_INVOICE_MODAL: {
			return {
				...state,
				changeInvoice: false,
			};
		}
		case types.SET_CHANGE_DELIVERY_CALENDAR_MODAL: {
			return {
				...state,
				deliveryCalendar: !state.deliveryCalendar,
			};
		}
		case types.CLOSE_CHANGE_DELIVERY_CALENDAR_MODAL: {
			return {
				...state,
				deliveryCalendar: false,
			};
		}
		case types.SET_MODAL_FILTER: {
			return {
				...state,
				filterModal: !state.filterModal,
			};
		}
		case types.CLOSE_MODAL_FILTER: {
			return {
				...state,
				filterModal: false,
			};
		}
		default:
			return state;
	}
};
